import AxiosInstance from "./api";

export const JournalVoucher10Service = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/journal-voucher-10s/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/journal-voucher-10s/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/journal-voucher-10s", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/journal-voucher-10s/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/journal-voucher-10s/" + id);
  },
};
